import React, { HTMLAttributes } from 'react';
import Gap from '../../interfaces/gap.interface';
import TestId from '../../interfaces/test-id.interface';
import { ReactComponent as LogoInline } from './logo-inline.svg';
import { ReactComponent as LogoStacked } from './logo-stacked.svg';

export interface Props extends HTMLAttributes<SVGElement>, Gap, TestId {
  /** The visual representation (stacked vs in line - defaults to 'inline') */
  variant?: 'stacked' | 'inline';
}

/** The logo */
const Logo = ({ variant = 'inline', gap = 'none', testId }: Props): React.ReactElement => {
  const Component = variant === 'stacked' ? LogoStacked : LogoInline;
  return (
    <Component
      title={`neuroCAD Logo ${variant}`}
      className={`block ${variant === 'stacked' ? 'm-auto' : ''} gap--${gap}`}
      data-testid={testId}
    />
  );
};

export default Logo;
